<main class="main">
  <section class="wrap-title"
    [ngStyle]="{'background-image': 'url(https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Contato_1920x324.png)'}">
    <div class="layout">
      <h1 class="title-page">Compra</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="left">
        <p>Fale com a gente por meio de um dos nossos canais:</p>
        <figure class="fig">
          <img
            src="https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2021/08/Captura-de-Tela-2021-08-30-%C3%A0s-19.19.08.png"
            alt="Contato" />
        </figure>
      </div>
      <div *ngIf="emailEnviado" class="right">
        <div class="ckeditor">
          <p><strong>Contato enviado com sucesso. Em breve nossa equipe estará entrando em contato</strong></p>
        </div>
        <br>
        <hr>
        <br>
        <button (click)="enviarOutro()" class="btn gradient">Enviar um novo contato</button>
      </div>
      <div *ngIf="!emailEnviado" class="right">
        <p><strong>Preencha os dados abaixo que nossa equipe entrará em contato com você:</strong></p>

        <!-- Formulário Angular com Reactive Forms -->
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <fieldset class="full">
            <input type="text" formControlName="nome" placeholder="Seu nome" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.nome.errors }" />
          </fieldset>

          <fieldset class="full">
            <input type="email" formControlName="email" placeholder="Seu e-mail" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.email.errors }" />
          </fieldset>

          <fieldset class="full">
            <input type="text" formControlName="empresa" placeholder="Sua empresa" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.empresa.errors }" />
          </fieldset>

          <fieldset class="full">
            <input type="text" formControlName="celular" placeholder="Seu celular" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.celular.errors }" />
          </fieldset>

          <fieldset class="full">
            <select formControlName="assunto" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.assunto.errors }">
              <option value="">Selecione um assunto</option>
              <option value="Gostaria de comprar canetas magnéticas">
                Gostaria de comprar canetas magnéticas
              </option>
              <option value="Sou cliente e preciso falar com Suporte">
                Sou cliente e preciso falar com Suporte
              </option>
              <option value="Comercial - Quero conhecer as soluções">
                Comercial - Quero conhecer as soluções
              </option>
            </select>
          </fieldset>

          <fieldset class="full">
            <input type="number" formControlName="qty" placeholder="Digite a quantidade" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.qty.errors }" />
          </fieldset>

          <fieldset class="full">
            <textarea formControlName="mensagem" placeholder="Mensagem" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && formControls.mensagem.errors }"></textarea>
          </fieldset>

          <fieldset class="full">
            <button type="submit" class="btn gradient" [disabled]="contactForm.invalid">
              Enviar Mensagem
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </section>
</main>
